<template>
    <div class="expressBox video-container" @click="clickVideo" >
        <video autoplay loop ref="video" playsinline webkit-playsinline src="./video/1.mp4" type="video/mp4" @click="clickVideo">
        </video>
        <div class="playBtn" @click.stop="playVideo" v-if="playBtnShow"></div>
    </div>
   
  </template>
  
  <script>
  export default {
    name: "adjustPageThree",
    data() {
      return {
        playBtnShow: true,
        campaignid: '',
        adgroupid: '',
        keyword: '',
        gclid: '',
        gbraid: '',
        wbraid: '',
      };
    },
    created() {
      const { campaignid, adgroupid, keyword, gclid, gbraid, wbraid } = this.$route.query;
      this.campaignid = campaignid || 0;
      this.adgroupid = adgroupid || 0;
      this.keyword = keyword || 0;
      this.gclid = gclid || 0;
      this.gbraid = gbraid || 0;
      this.wbraid = wbraid || 0;
    },
    mounted() {
      
    },
    methods: { 
      clickVideo(){
        window.location.href = `https://app.adjust.com/1gntu7x9?campaign=${this.campaignid}&adgroup=${this.adgroupid}&creative=${this.keyword}&gclid=${this.gclid}&gbraid=${this.gbraid}&wbraid=${this.wbraid}`
      },
      playVideo(){
        this.$refs.video.play();
        this.playBtnShow = false;
      }
    },
  };
  </script>
  
  <style scoped>
  .expressBox{
    width: 100vw;
    height: 100vh;
    overflow: hidden;
  }
    /* 视频容器样式 */
    .video-container {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height:100vh;
  }
  /* 视频元素样式 */
  .video-container video {
    width: 100%;
    height:100vh;
    object-fit: cover; /* 保持宽高比，同时填充容器 */
  }
  .playBtn{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background: url('./play.svg') no-repeat center center;
  }
  </style>
  